import React, { useState, useEffect } from 'react';
import { RecaptchaVerifier, linkWithPhoneNumber } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore'; 
import { auth, db } from '../../firebase/config';

export default function PhoneVerification({ user, isAlreadyVerified }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [step, setStep] = useState(isAlreadyVerified ? 'verified' : 'phone'); // 'phone', 'code', 'verified'
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // THE FIX: Clear out any old "ghost" reCAPTCHAs before creating a new one
    if (step === 'phone') {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
      
      window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
        'size': 'invisible',
        'callback': (response) => {
          console.log("reCAPTCHA solved");
        }
      });
    }
  }, [step]);

  const handleSendText = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const formattedPhone = phoneNumber.startsWith('+') ? phoneNumber : `+1${phoneNumber.replace(/\D/g, '')}`;

    if (formattedPhone.length < 11) {
      setError('Please enter a valid 10-digit phone number.');
      setLoading(false);
      return;
    }

    try {
      const appVerifier = window.recaptchaVerifier;
      const confirmationResult = await linkWithPhoneNumber(user, formattedPhone, appVerifier);
      
      window.confirmationResult = confirmationResult;
      setStep('code');
    } catch (err) {
      console.error("SMS Error:", err);
      setError("Failed to send text. Check the phone number format or try again later.");
      
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.render().then(widgetId => window.grecaptcha.reset(widgetId));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await window.confirmationResult.confirm(verificationCode);
      const verifiedUser = result.user;

      await setDoc(doc(db, 'users', user.uid), {
        isVerified: true,
        phoneNumber: verifiedUser.phoneNumber
      }, { merge: true });

      setStep('verified');
      alert("Success! You are now officially verified.");
      
    } catch (err) {
      console.error("Code Verification Error:", err);
      setError("Invalid code. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (step === 'verified') {
    return (
      <div style={{ padding: '20px', backgroundColor: '#d4edda', color: '#155724', borderRadius: '8px', border: '1px solid #c3e6cb', marginTop: '20px' }}>
        <h3 style={{ margin: '0 0 5px 0' }}>✓ Account Verified</h3>
        <p style={{ margin: 0, fontSize: '14px' }}>Your identity has been confirmed via SMS. Your listings will now feature the verified badge.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #ddd', marginTop: '20px' }}>
      <h3 style={{ margin: '0 0 15px 0' }}>Verify Your Identity</h3>
      
      <div id="recaptcha-container"></div>

      {error && <div style={{ color: 'red', marginBottom: '15px', fontSize: '14px', fontWeight: 'bold' }}>{error}</div>}

      {step === 'phone' && (
        <form onSubmit={handleSendText}>
          <p style={{ margin: '0 0 15px 0', fontSize: '14px', color: '#666' }}>We will send a one-time SMS code to your phone to verify you are a real human.</p>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input 
              type="tel" 
              placeholder="(555) 555-5555" 
              value={phoneNumber} 
              onChange={(e) => setPhoneNumber(e.target.value)}
              style={{ flex: 1, padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px' }}
              required
            />
            <button type="submit" disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Sending...' : 'Send Text'}
            </button>
          </div>
        </form>
      )}

      {step === 'code' && (
        <form onSubmit={handleVerifyCode}>
          <p style={{ margin: '0 0 15px 0', fontSize: '14px', color: '#666' }}>Enter the 6-digit code we just sent to your phone.</p>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input 
              type="text" 
              placeholder="123456" 
              value={verificationCode} 
              onChange={(e) => setVerificationCode(e.target.value)}
              maxLength="6"
              style={{ flex: 1, padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px', letterSpacing: '4px', textAlign: 'center' }}
              required
            />
            <button type="submit" disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Checking...' : 'Verify Code'}
            </button>
          </div>
          <button type="button" onClick={() => setStep('phone')} style={{ background: 'none', border: 'none', color: '#007bff', fontSize: '12px', marginTop: '15px', cursor: 'pointer', textDecoration: 'underline' }}>
            Change Phone Number
          </button>
        </form>
      )}
    </div>
  );
}